/**
 * คอมโพเนนต์ทั้งระบบเป็นฟังก์ชัน `(props) => string` (HTML) — ไม่มีเฟรมเวิร์ก
 * ทดสอบได้ใน Node ล้วน (ไม่ต้องมี DOM) และหน้าจอพนักงานมีไม่กี่หน้า พฤติกรรมผูกด้วย event delegation ใน main.ts
 * ค่าที่มาจากผู้ใช้/ฐานข้อมูลผ่าน `esc()` เสมอ — template tag `html` escape ให้อัตโนมัติ ยกเว้นค่าที่ห่อด้วย `raw()`
 */

const ESC: Record<string, string> = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
export const esc = (v: unknown): string => String(v ?? "").replace(/[&<>"']/g, (c) => ESC[c]!);

export class Raw {
  constructor(readonly s: string) {}
  toString(): string { return this.s; }
}
export const raw = (s: string): Raw => new Raw(s);

/** `html\`<b>${name}</b>\`` — สตริงธรรมดาถูก escape · `Raw` และผลของ `html` เองแทรกตรง ๆ · array ต่อกัน · null/false/undefined หาย */
export function html(strings: TemplateStringsArray, ...values: unknown[]): Raw {
  let out = "";
  strings.forEach((s, i) => {
    out += s;
    if (i < values.length) out += part(values[i]);
  });
  return new Raw(out);
}
function part(v: unknown): string {
  if (v === null || v === undefined || v === false) return "";
  if (v instanceof Raw) return v.s;
  if (Array.isArray(v)) return v.map(part).join("");
  return esc(v);
}

/** ตัวเลขเงินทั้งระบบผ่านตัวเดียว (COMPONENTS.md หลักการ) — tabular ใช้ CSS · ค่าติดลบมีเครื่องหมาย */
export function formatTHB(amount: number, showDecimals = true): string {
  return new Intl.NumberFormat("th-TH", {
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0,
  }).format(amount);
}
